import React from 'react';
import { addElement } from '../../../actions/CreateSiteActions/createSiteActions'
import { connect } from 'react-redux';
import PeoplePicker  from '../../formFields/PeoplePicker';
import { ADD_OWNER, ADD_APPROVER } from '../../../actions/types';
import { getUserManager } from '../../../actions/userActions';
import {Icon} from '@fluentui/react';
import PropTypes from 'prop-types'
import { isOwnerValid } from './Validator';
import InfoTooltip from '../../formFields/InfoTooltip';


const warningIcon = <div className='warning-inline warning-nolabel'><Icon  iconName="Warning"/></div>

class Owner extends React.Component {

    componentDidMount() {
        this._initializeOwner();
    }

    componentDidUpdate(prevProps) {
        if(prevProps.currentUser !== this.props.currentUser) {
            this._initializeOwner();
        }
    }

    _initializeOwner() {
        const owner = this.props.currentUser;
        if(!this.props.owner && owner) {
            this.props.addOwner(owner);
            this.props.getUserManager(owner.id);
        }
    }

    _onSelectedUser = (items) => {
        const owner = items[0] || null;
        this.props.addOwner(owner);
        if(owner) {
            this.props.getUserManager(owner.id);
        } else {
            this.props.addApprover(null);
        }
    }

    render() {
        const warning = this.props.possibleWarning && !isOwnerValid()
                        ? warningIcon : null;
        const error = warning && 'Owner cannot be empty';

        return (
            <div className='wizard-inside-third'>
                <div className="item-Owner">
                    Owner
                    <InfoTooltip content='The person responsible for Site management and governance who have the highest level of permission on the Site. It can be changed later in Manage Center.' />
                </div>
                {warning}
                <PeoplePicker
                    defaultUsers={this.props.owner} 
                    onSelectedUsers={this._onSelectedUser} 
                    itemLimit={1}
                    errorMessage={error}
                />
            </div>
        );
    }
}

Owner.propTypes = {
    addOwner: PropTypes.func.isRequired,
    addApprover: PropTypes.func.isRequired,
    getUserManager: PropTypes.func.isRequired,
    owner: PropTypes.object,
    currentUser: PropTypes.object
}


const mapActionToProp = (dispatch) => ({
    addOwner: (element) => { dispatch(addElement(ADD_OWNER, element)) },
    addApprover: (element) => { dispatch(addElement(ADD_APPROVER, element)) },
    getUserManager: (userId) => dispatch(getUserManager(userId))
})

const mapStateToProps  = state => ({
    owner: state.newSite.Owner,
    currentUser: state.user.currentUser,
    possibleWarning : state.wizard.nextStepRequested
})

export default connect(mapStateToProps, mapActionToProp)(Owner);







// WEBPACK FOOTER //
// ./src/components/CreateSite/Step4/Owner.js